import React from "react";
import { Modal, Box, Button } from "@mui/material";

function ConfirmRefreshModal({ open, onClose, onConfirm, isMobile = false }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: 3,
          width: 380,
        }}
      >
        <h3 style={{ fontWeight: "bold", fontSize: "20px" }}>Confirmation</h3>
        <p style={{ marginTop: 8, marginBottom: 24 }}>
          You have updated the data associated with the tag.
          <br />
          Do you want to refresh the tag content right now?
        </p>

        <div style={{ display: "flex", justifyContent: "end", gap: 12 }}>
          <Button
            onClick={onClose}
            variant="contained"
            color="error"
            sx={{
              textTransform: "none",
              background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
              color: "#fff",
              boxShadow: "none",
              "&:hover": {
                background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                opacity: 0.95,
                boxShadow: "none"
              },
              "&.Mui-disabled": {
                background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                opacity: 0.5,
                color: "#fff"
              }
            }}
          >
            No
          </Button>

          {/* YES button — Mobile gets #158394, Web stays MUI primary */}
          <Button
            onClick={onConfirm}
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "rgb(90, 28, 47)",
              "&:hover": {
                backgroundColor: "rgb(70, 20, 35)",
              },
              "&.Mui-disabled": {
                backgroundColor: "rgba(90, 28, 47, 0.4)",
                color: "#fff",
              },
            }}
          >
            Yes
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default ConfirmRefreshModal;
